import * as React from 'react';
import { SVGProps } from 'react';

const IconTableSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M2 2v12h12V2H2zm5 10H4V9h3v3zm0-5H4V4h3v3zm5 5H9V9h3v3zm0-5H9V4h3v3z" />
  </svg>
);
export default IconTableSizeS;
